"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeDefaultUserBlob = exports.LoadUser = void 0;

var OperationBase_1 = require("../OperationBase");

var MsaTicketSet_1 = require("../../MsaTicketSet");

var StepTracker_1 = require("../StepTracker");

var ITelemetryClient_1 = require("../../ITelemetryClient");

var MsaTicketCache_1 = require("../../MsaTicketCache");

var Utils_1 = require("../../Utils");

var XalInternalError_1 = require("../../errors/XalInternalError");

var XalInternalErrorType_1 = require("../../errors/XalInternalErrorType");

var LoadUserStep;

(function (LoadUserStep) {
  LoadUserStep["Start"] = "Start";
  LoadUserStep["ReadingDefaultUser"] = "ReadingDefaultUser";
  LoadUserStep["ReadingTicketSet"] = "ReadingTicketSet";
  LoadUserStep["Done"] = "Done";
})(LoadUserStep || (LoadUserStep = {}));

var LoadUser =
/** @class */
function (_super) {
  __extends(LoadUser, _super);

  function LoadUser(telemetryClient, authConfig, memoryCache, storage, isWeb, msaUserId) {
    var _this = _super.call(this, telemetryClient) || this;

    _this.authConfig = authConfig;
    _this.memoryCache = memoryCache;
    _this.storage = storage;
    _this.isWeb = isWeb;
    _this.msaUserId = msaUserId;
    _this.step = new StepTracker_1.StepTracker(ITelemetryClient_1.Area.LoadDefaultUser, LoadUserStep.Start);
    return _this;
  }

  LoadUser.Default = function (telemetryClient, authConfig, memoryCache, storage, isWeb) {
    return new LoadUser(telemetryClient, authConfig, memoryCache, storage, isWeb);
  };

  LoadUser.WithId = function (telemetryClient, authConfig, memoryCache, storage, msaUserId, isWeb) {
    return new LoadUser(telemetryClient, authConfig, memoryCache, storage, isWeb, msaUserId);
  };

  LoadUser.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      var defaultUserKey, data, error_1, msaUserId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.msaUserId) {
              this.readTicketSet(this.msaUserId);
              return [2
              /*return*/
              ];
            }

            this.step.advance(LoadUserStep.ReadingDefaultUser);
            defaultUserKey = MsaTicketCache_1.MsaTicketCache.makeDefaultUserKey(this.authConfig);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.storage.read(defaultUserKey)];

          case 2:
            data = _a.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _a.sent();
            Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to read default user with error: " + error_1);
            this.step.advance(LoadUserStep.Done);
            this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to read default user"));
            return [2
            /*return*/
            ];

          case 4:
            Utils_1.assert(this.step.currentStep === LoadUserStep.ReadingDefaultUser);

            if (Utils_1.isNullOrWhiteSpace(data)) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Information, "No default user found");
              this.step.advance(LoadUserStep.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to read default user, empty data"));
              return [2
              /*return*/
              ];
            }

            try {
              msaUserId = parseDefaultUserBlob(data);
            } catch (error) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to deserialize default user information: " + error);
              this.step.advance(LoadUserStep.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to read default user information"));
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , this.readTicketSet(msaUserId)];

          case 5:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  LoadUser.prototype.readTicketSet = function (msaUserId) {
    return __awaiter(this, void 0, void 0, function () {
      var ticketSet, ticketSetKey, data, error_2, parsedData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.step.advance(LoadUserStep.ReadingTicketSet);
            ticketSet = this.memoryCache.getUser(msaUserId);

            if (ticketSet) {
              this.step.advance(LoadUserStep.Done);
              this.succeed(ticketSet);
              return [2
              /*return*/
              ];
            }

            ticketSetKey = MsaTicketCache_1.MsaTicketCache.makeTicketSetKey(this.authConfig, msaUserId);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.storage.read(ticketSetKey)];

          case 2:
            data = _a.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            error_2 = _a.sent();
            Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to read user ticket set with error: " + error_2);
            this.step.advance(LoadUserStep.Done);
            this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to read user ticket set with error"));
            return [2
            /*return*/
            ];

          case 4:
            Utils_1.assert(this.step.currentStep === LoadUserStep.ReadingTicketSet);

            if (Utils_1.isNullOrWhiteSpace(data)) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Information, "No user ticket found");
              this.step.advance(LoadUserStep.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "No user ticket found"));
              return [2
              /*return*/
              ];
            }

            try {
              parsedData = MsaTicketSet_1.MsaTicketSet.deserializeTicketSet(data, this.isWeb);
              this.memoryCache.insertToken(parsedData);
              this.step.advance(LoadUserStep.Done);
              this.succeed(parsedData);
            } catch (error) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to deserialize token set: " + error);
              this.step.advance(LoadUserStep.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to deserialize token set"));
              return [2
              /*return*/
              ];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return LoadUser;
}(OperationBase_1.OperationBase);

exports.LoadUser = LoadUser;

function parseDefaultUserBlob(data) {
  var parsedData = JSON.parse(data);

  if (parsedData && !Utils_1.isNullOrWhiteSpace(parsedData.default)) {
    return parsedData.default;
  } else {
    throw new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.ParseError, "Default user msa id is empty");
  }
}

function serializeDefaultUserBlob(msaUserId) {
  var result = {
    default: msaUserId
  };
  return JSON.stringify(result);
}

exports.serializeDefaultUserBlob = serializeDefaultUserBlob;